import { makeSimpleDomRect } from '../dom.js';

const POSITION_AREA_MAP = {
    top: { y: 'start' },
    bottom: { y: 'end' },
    left: { x: 'start' },
    right: { x: 'end' },
    center: {},
    'span-top': { y: 'span-start' },
    'span-bottom': { y: 'span-end' },
    'span-left': { x: 'span-start' },
    'span-right': { x: 'span-end' },
    'x-start': { x: 'start' },
    'y-start': { y: 'start' },
    'x-end': { x: 'end' },
    'y-end': { y: 'end' },
};
const POSITION_AREA_FLIP_MAP = {
    start: 'end',
    end: 'start',
    center: 'center',
    'span-start': 'span-end',
    'span-end': 'span-start',
};
const POSITION_AREA_CACHE = new Map();
function getViewportRect(margin, ownerWindow = window) {
    return makeSimpleDomRect(0 + margin.left, 0 + margin.top, ownerWindow.innerWidth - margin.left - margin.right, ownerWindow.innerHeight - margin.top - margin.bottom);
}
function fitsInViewport(target, margin, axis, ownerWindow = window) {
    const viewport = getViewportRect(margin, ownerWindow);
    const fitsInX = axis === 'y' || (target.left >= viewport.left && target.right <= viewport.right);
    const fitsInY = axis === 'x' || (target.top >= viewport.top && target.bottom <= viewport.bottom);
    return fitsInY && fitsInX;
}
function computeViewportOverflow(target, margin, ownerWindow = window) {
    const viewport = getViewportRect(margin, ownerWindow);
    return {
        top: Math.max(0, viewport.top - target.top),
        left: Math.max(0, viewport.left - target.left),
        bottom: Math.max(0, target.bottom - viewport.bottom),
        right: Math.max(0, target.right - viewport.right),
    };
}
function flipPositionArea(positionArea, axis) {
    const flipped = { ...positionArea };
    if (axis !== 'y')
        flipped.x = POSITION_AREA_FLIP_MAP[flipped.x];
    if (axis !== 'x')
        flipped.y = POSITION_AREA_FLIP_MAP[flipped.y];
    return flipped;
}
function positionGeneric(anchorStart, anchorEnd, targetSize, anchorSize, area, margin = 0) {
    switch (area) {
        case 'start':
            // Before anchor
            return anchorStart - targetSize - margin;
        case 'end':
            // After anchor
            return anchorEnd + margin;
        case 'center':
            // Centered on anchor
            return anchorStart + (anchorSize - targetSize) / 2;
        case 'span-start':
            // Covers anchor, extends toward start
            return anchorEnd - targetSize - margin;
        case 'span-end':
            // Covers anchor, extends toward end
            return anchorStart + margin;
    }
}
function resolvePositionArea(area) {
    let result = POSITION_AREA_CACHE.get(area);
    if (!result) {
        result = { x: 'center', y: 'center' };
        const sides = area.split(' ');
        for (const side of sides) {
            const { x, y } = POSITION_AREA_MAP[side];
            if (x)
                result.x = x;
            if (y)
                result.y = y;
        }
        POSITION_AREA_CACHE.set(area, result);
    }
    return result;
}
function resolveMargin(margin = 0) {
    if (typeof margin === 'number') {
        return { top: margin, right: margin, bottom: margin, left: margin };
    }
    const { top = 0, right = 0, bottom = 0, left = 0 } = margin;
    return { top, right, bottom, left };
}
function resolveMarginAxis(margin = 0) {
    if (typeof margin === 'number') {
        return { x: margin, y: margin };
    }
    const { x = 0, y = 0 } = margin;
    return { x, y };
}
function resolveElement(getElement) {
    return typeof getElement === 'function' ? getElement() : getElement.current;
}

export { computeViewportOverflow, fitsInViewport, flipPositionArea, getViewportRect, positionGeneric, resolveElement, resolveMargin, resolveMarginAxis, resolvePositionArea };
//# sourceMappingURL=positioner.utils.js.map
